// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1CbTQ","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2P8BM"};